import React from "react";
import PortalLayout from "../components/PortalLayout";

export default function Terms() {
    return (
        <PortalLayout>
            <section className="max-w-2xl mx-auto px-6 md:px-12 pt-20 pb-32" data-testid="terms-page">
                <span className="font-label text-[11px] text-[#cfa052]">Legal</span>
                <h1 className="mt-4 font-serif-display text-5xl md:text-6xl tracking-tighter text-[#e8e4db]">Terms of Use</h1>
                <p className="mt-3 font-poetic text-sm text-[#6e6a62]">Last updated: February 2026</p>

                <div className="mt-12 space-y-8 font-poetic text-[#9a958a] text-lg leading-relaxed">
                    <p>
                        The Angel Squad Portal is a private space provided to paid members for the purpose of joining the community and selecting an Angel.
                    </p>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Membership</h2>
                        <p>
                            Access is granted to paid users only. The portal is not open to the public. Sharing your sign-in is not permitted.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Selection</h2>
                        <p>
                            Each member may select one Angel. The Angel and its number become linked to your account. Administrators may re-assign on request.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Conduct</h2>
                        <p>
                            Be kind in your messages. Misuse of the portal — automated scraping, impersonation, or abuse — will end your membership without refund.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Changes</h2>
                        <p>
                            We may update these terms as the squad grows. Material changes will be announced inside the portal.
                        </p>
                    </div>
                </div>
            </section>
        </PortalLayout>
    );
}
